// Temporary experiment name
export const EXPERIMENT = Math.random() > 0.5 ? 'start-up' : undefined;
